import { VrockFileHandler } from '../../utils/VrockFileHandler';
import { DialogHandlerCore } from '../../../framework/components/dialog/DialogHandlerCore';
import { SessionMemory } from '../../utils/SessionMemory';
export class DialogHandler extends DialogHandlerCore {
  static arMarkerListDialogId = 'arMarkerListDialogId';
  static tutorialDialogId = 'tutorialDialog';
  static qrDialogId = 'qr_dialog';
  static templateDialogId = 'template_dialog';
  static vrockFileUploadDialog = 'vrock_file_upload_dialog';
  static saveBlockDialogId = 'save_block_dialog';
  static sketchFabAuthDialogId = 'sketchFabAuthDialogId';
  static sketchFabListDialogId = 'sketchFabListDialogId';
  // static fileManagerDialogId = 'fileManagerDialogId';
  static flickerDialogId = 'flickerDialogId';
  static recoverBackupDialogId = 'recoverBackupDialogId';
  static delUserDialogId = 'delUserDialogId';
  static contactUsDialogId = 'contactUsDialogId';
  static documentSlideDialogId = 'documentSlideDialogId';
  static singInDialogId = 'singInDialogId';
  static createAccountId = 'create_account';
  static notificationId = 'notificationId';
  static gpsSelectDialogId = 'gpsSelectDialogId';
  static oauthDialogId = 'oauthDialogId';
  static thumbnailEditorDialogId = 'thumbnailEditorDialogId';
  static classRoomDialogId = 'classRoomDialog';
  static classRoomProgramDialogId = "classRoomProgramDialog"

  static showSingInDialog(): void {
    this.show(this.singInDialogId);
  }
  static showCreateAccountDialog(): void {
    this.show(this.createAccountId);
  }
  static showSaveDialog(): void {
    this.show(this.saveBlockDialogId);
  }
  static showQRDialog(): void {
    this.show(this.qrDialogId);
  }
  static showVrockFileUploadDialog(): void {
    this.show(this.vrockFileUploadDialog);
  }
  static showTemplateDialog(): void {
    this.show(this.templateDialogId);
  }
  static showTutorialDialog(): void {
    this.show(this.tutorialDialogId);
  }
  static showArMarkerListDialog(): void {
    this.show(this.arMarkerListDialogId);
  }
  static showThumbnailEditorDialog(): void {
    this.show(this.thumbnailEditorDialogId);
  }

  // static showFileManagerDialog(): void {
  //   this.show(this.fileManagerDialogId);
  // }
  static showFlickerDialog(): void {
    this.show(this.flickerDialogId);
  }
  static showNotificationDialog(): void {
    this.show(this.notificationId);
  }

  static recoverItem: VrockFileHandler = null;
  static showRecoverBackupDialog(item: VrockFileHandler): void {
    this.recoverItem = item;
    this.show(this.recoverBackupDialogId);
  }
  static showDelUserDialog(): void {
    this.show(this.delUserDialogId);
  }

  static showContactUsDialog(): void {
    this.show(this.contactUsDialogId);
  }
  static showDocumentSlideDialog(): void {
    this.show(this.documentSlideDialogId);
  }
  static showGpsDialog(): void {
    this.show(this.gpsSelectDialogId);
  }
  static showOAuthDialog(): void {
    this.show(this.oauthDialogId);
  }

  static showClassRoomDialog(): void {
    this.show(this.classRoomDialogId);
  }
  static showClassRoomProgramDialog(): void {
    this.show(this.classRoomProgramDialogId);
  }

  /**
   * ローカルにキーが保存されていなければ認証ダイアログを出す
   */
  static showSketchFabAuthDialog(): void {
    const memory = SessionMemory.instance;
    if (memory.existsSkechFabAuthCode) {
      DialogHandler.showSketchFabListDialog();
    } else {
      this.show(this.sketchFabAuthDialogId);
    }
  }

  /**
   * Skechfabのリストダイアログを出す。（showSketchFabAuthDialogで判断して利用,BlocklyPageでも認証コード受け取った後に利用）
   */
  static showSketchFabListDialog(): void {
    this.show(this.sketchFabListDialogId);
  }
}
